/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lpdataroom_Loading3Inputs */

const en_coinvestments_lpdataroom_loading3 = /** @type {(inputs: Coinvestments_Lpdataroom_Loading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading data room...`)
};

/**
* | output |
* | --- |
* | "Loading data room..." |
*
* @param {Coinvestments_Lpdataroom_Loading3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpdataroom_loading3 = /** @type {((inputs?: Coinvestments_Lpdataroom_Loading3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpdataroom_Loading3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpdataroom_loading3(inputs)
});
export { coinvestments_lpdataroom_loading3 as "coInvestments_lpDataRoom_loading" }